module.exports = __webpack_public_path__ + "static/media/omniknight.941c790b.png";